import { Alert } from 'components/core-v2/atoms'
import LogRocket from 'logrocket'
import { FC, useEffect } from 'react'
import { ErrorBoundary } from 'react-error-boundary'

import classes from './index.module.scss'

const ErrorFallback = () => {
  useEffect(() => {
    LogRocket.captureMessage('Something went wrong!')
  }, [])
  return (
    <div className={classes.root} role="alert">
      <Alert title="Something has gone wrong" type="error">
        Please reload the page and retry the action, and if the problem persists, please contact us.
      </Alert>
    </div>
  )
}

export const GenericErrorBoundary: FC = ({ children }) => (
  <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>
)
